module.exports = __webpack_public_path__ + "img/統計学入門_5_1_問題.fbabad3c.png";